import axios from 'axios'
import axiosRetry from 'axios-retry'
import { HTTP_TIMEOUT_MILLISECONDS, ZKEX_API_BASE_URL } from '../../config'

export interface ApiV1Response<T = any> {
  code: number // 200: success, others: error
  msg: string // code not 200, error message
  data: T // response data only when code === 200
}

export class ApiError extends Error {
  readonly msg: string = ''
  constructor(
    message: string,
    readonly code: number,
  ) {
    super(message)

    this.msg = message
  }
}

export const http = axios.create({
  baseURL: ZKEX_API_BASE_URL,
  headers: {},
  timeout: HTTP_TIMEOUT_MILLISECONDS,
})

axiosRetry(http, {
  retries: 3,
})
